// bao migrate skip
import "./../../bindings/bao-searcher";
import * as $ from "jquery";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import * as moment from "moment";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";

class FullYearScheduleReportModel {
    Years: number[] = [];
    ShiftEntries: any[];
    ShiftScheduleItems: any[];
    Months: any[] = [];
    Calendar: any[];
    Week: number = 0;
    // pass moment to view
    moment = moment;
    SelectedYear: KnockoutObservable<number> = ko.observable(new Date().getFullYear());
    SelectedEmployeeId: KnockoutObservable<string> = ko.observable(undefined);
    PersonFullName: KnockoutObservable<string> = ko.observable("");
    parent: any;
    Bao = Bao;
    FiltersEnabled: KnockoutObservable<boolean> = ko.observable(false);
    constructor(parent: any) {
        this.parent = parent;
    }
    InitUrl() {
        return "";
    }
    init() {
        this.parent.TabPage.IsLoading(true);
        var urlQuery = baoRouter.getRouteValue("?param", this.parent.TabPage);
        this.FiltersEnabled = Bao.Session.HasPermission("TeamScheduleFilterShiftPlan", '1A38B671-948C-42EE-B80D-F6B9A12814B6');
        return $.when(this.loadMetaData(urlQuery));
    }
    loadMetaData(urlQuery) {
        return Bao.post("ShiftSchedule/FullYearScheduleMetaData", JSON.stringify({
            employeeId: (urlQuery) ? urlQuery.employeeId : null
        }))
            .done(result => {
            //ko.map.fromJS(result, this); this maps also properties to observables
            //this.Years = result.Years;
            for (var r in result.Years) {
                if (result.Years[r].Key != "" && result.Years[r].Key != null)
                    this.Years.push(result.Years[r].Key);
            }
            if (urlQuery && urlQuery.year) {
                this.SelectedYear(urlQuery.year);
            }
            else {
                var DatumAkt = new Date();
                var JahrAkt = DatumAkt.getFullYear();
                this.SelectedYear(JahrAkt);
            }
            for (var r in result.Months) {
                this.Months.push(result.Months[r]);
            }
            if (result.CurrentPerson != null) {
                this.SelectedEmployeeId(result.CurrentPerson.ConfigurationItemId);
                this.PersonFullName(result.CurrentPerson.FullName);
            }
            this.ShiftEntries = result.ShiftEntries;
            //this.Months = result.Shift            
            this.parent.TabPage.Title(result.TabTitle);
            this.parent.TabPage.IsLoading(false);
        });
    }
    Download() {
        if (this.SelectedEmployeeId() == null || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/FullYearScheduleReportDownload", JSON.stringify({
                year: this.SelectedYear(),
                employeeId: this.SelectedEmployeeId(),
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
}
export default FullYearScheduleReportModel;